<main class="dl-page">
  <section *ngIf="state === 'error'" class="dl-error ftds-chamfer-bordered" role="alert">
    <i class="pi pi-cloud-download dl-error-icon"></i>
    <h2>{{ 'downloads.errTitle' | transloco }}</h2>
    <p>{{ 'downloads.errText' | transloco }}</p>
    <button type="button" class="dl-retry" (click)="load()">
      <i class="pi pi-refresh"></i>
      {{ 'downloads.retry' | transloco }}
    </button>
  </section>

  <ng-container *ngIf="state !== 'error'">
    <header class="dl-header">
      <div class="dl-product">
        <ng-container *ngIf="manifest; else productLoading">
          <img class="dl-logo" src="assets/img/ftpilot.svg" alt="FT Pilot" width="52" height="45" />
          <div class="dl-product-text">
            <h1>{{ 'downloads.product' | transloco }}</h1>
            <p>{{ 'downloads.desc' | transloco }}</p>
          </div>
        </ng-container>
        <ng-template #productLoading>
          <p-skeleton width="52px" height="45px"></p-skeleton>
          <div class="dl-product-text">
            <p-skeleton width="11rem" height="1.9rem"></p-skeleton>
            <p-skeleton width="24rem" height="0.95rem"></p-skeleton>
          </div>
        </ng-template>
      </div>
      <div class="dl-version">
        <ng-container *ngIf="manifest; else versionLoading">
          <span class="dl-version-number">{{ manifest.version }}</span>
          <span class="dl-version-date">{{ manifest.releasedAt }}</span>
        </ng-container>
        <ng-template #versionLoading>
          <p-skeleton width="5.5rem" height="1.6rem"></p-skeleton>
          <p-skeleton width="4.5rem" height="0.8rem"></p-skeleton>
        </ng-template>
      </div>
    </header>

    <div class="dl-table" [attr.aria-busy]="state === 'loading' ? 'true' : null">
      <div class="dl-head dl-grid" aria-hidden="true">
        <ng-container *ngIf="manifest; else headLoading">
          <span>{{ 'downloads.colSystem' | transloco }}</span>
          <span>{{ 'downloads.colFile' | transloco }}</span>
          <span class="dl-col-size">{{ 'downloads.size' | transloco }}</span>
          <span></span>
        </ng-container>
        <ng-template #headLoading>
          <p-skeleton width="4rem" height="0.7rem"></p-skeleton>
          <p-skeleton width="3rem" height="0.7rem"></p-skeleton>
          <div class="dl-skeleton-end">
            <p-skeleton width="2.5rem" height="0.7rem"></p-skeleton>
          </div>
          <span></span>
        </ng-template>
      </div>

      <ng-container *ngIf="manifest; else rowsLoading">
        <div *ngFor="let file of visibleFiles" class="dl-row dl-grid">
          <div class="dl-system">
            <span class="dl-bar" [attr.data-os]="file.os"></span>
            <div class="dl-system-text">
              <span class="dl-system-name">{{ 'downloads.' + file.os | transloco }}</span>
              <span *ngIf="formatKey(file.fileName) as key" class="dl-sub">{{ key | transloco }}</span>
            </div>
          </div>
          <div class="dl-file">
            <span class="dl-file-name">{{ file.fileName }}</span>
            <span class="dl-sub">{{ file.requirement }}</span>
          </div>
          <span class="dl-size">{{ formatSize(file.sizeBytes) }}</span>
          <a
            class="dl-button ftds-chamfer-sm"
            [href]="file.url"
            [attr.download]="file.fileName"
            [attr.aria-label]="('downloads.download' | transloco) + ' ' + file.fileName"
            rel="noopener"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M12 3v12m0 0l-5-5m5 5l5-5M4 21h16" />
            </svg>
            {{ 'downloads.download' | transloco }}
          </a>
        </div>

        <p *ngIf="!visibleFiles.length" class="dl-empty">{{ 'downloads.empty' | transloco }}</p>
      </ng-container>

      <ng-template #rowsLoading>
        <div *ngFor="let row of skeletonRows" class="dl-row dl-grid" aria-hidden="true">
          <div class="dl-system">
            <span class="dl-bar"></span>
            <div class="dl-system-text">
              <p-skeleton width="5.5rem" height="0.95rem"></p-skeleton>
              <p-skeleton width="3.5rem" height="0.72rem"></p-skeleton>
            </div>
          </div>
          <div class="dl-file">
            <p-skeleton width="58%" height="0.8rem"></p-skeleton>
            <p-skeleton width="36%" height="0.72rem"></p-skeleton>
          </div>
          <div class="dl-skeleton-end">
            <p-skeleton width="3.5rem" height="0.85rem"></p-skeleton>
          </div>
          <div class="dl-skeleton-end">
            <p-skeleton width="8.5rem" height="2.4rem"></p-skeleton>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="dl-footer">
      <section *ngIf="!manifest || manifest.changelogUrl" class="dl-news">
        <div class="dl-panel-head">
          <ng-container *ngIf="manifest; else newsHeadLoading">
            <h2>{{ 'downloads.newsTitle' | transloco: { version: manifest.version } }}</h2>
            <span class="dl-version-date">{{ manifest.releasedAt }}</span>
          </ng-container>
          <ng-template #newsHeadLoading>
            <p-skeleton width="12rem" height="1rem"></p-skeleton>
            <p-skeleton width="4.5rem" height="0.8rem"></p-skeleton>
          </ng-template>
        </div>
        <div class="dl-news-body">
          <ng-container *ngIf="manifest; else newsBodyLoading">
            <div *ngIf="changelogState === 'loading'" aria-busy="true">
              <p-skeleton *ngFor="let i of skeletonRows" width="100%" height="16px" styleClass="dl-skeleton-row"></p-skeleton>
            </div>

            <div *ngIf="changelogState === 'error'" class="dl-changelog-error" role="alert">
              <p>{{ 'downloads.changelogErr' | transloco }}</p>
              <button type="button" class="dl-retry" (click)="loadChangelog()">
                <i class="pi pi-refresh"></i>
                {{ 'downloads.retry' | transloco }}
              </button>
            </div>

            <div *ngIf="changelogState === 'ready'" class="dl-changelog-body" [innerHTML]="changelogPreview"></div>

            <button type="button" class="dl-changelog" (click)="openChangelog()">
              {{ 'downloads.changelog' | transloco }}
            </button>
          </ng-container>
          <ng-template #newsBodyLoading>
            <div *ngFor="let item of skeletonRows" class="dl-skeleton-news" aria-hidden="true">
              <p-skeleton width="52%" height="0.88rem"></p-skeleton>
              <p-skeleton width="100%" height="0.84rem"></p-skeleton>
            </div>
          </ng-template>
        </div>
      </section>

      <section class="dl-before">
        <ng-container *ngIf="manifest; else beforeLoading">
          <h2>{{ 'downloads.beforeTitle' | transloco }}</h2>
          <ul>
            <li>{{ 'downloads.beforeMemory' | transloco }}</li>
            <li>{{ 'downloads.beforeDisk' | transloco }}</li>
            <li>{{ 'downloads.beforeAccount' | transloco }}</li>
          </ul>
        </ng-container>
        <ng-template #beforeLoading>
          <div class="dl-skeleton-before" aria-hidden="true">
            <p-skeleton width="9rem" height="1rem"></p-skeleton>
            <div class="dl-skeleton-list">
              <p-skeleton width="72%" height="0.85rem"></p-skeleton>
              <p-skeleton width="100%" height="0.85rem"></p-skeleton>
              <p-skeleton width="54%" height="0.85rem"></p-skeleton>
              <p-skeleton width="66%" height="0.85rem"></p-skeleton>
            </div>
          </div>
        </ng-template>
      </section>
    </div>
  </ng-container>
</main>

<p-dialog
  [(visible)]="changelogOpen"
  [header]="'downloads.changelogTitle' | transloco"
  [modal]="true"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="dl-changelog-dialog"
>
  <div *ngIf="changelogState === 'loading'" aria-busy="true">
    <p-skeleton *ngFor="let i of [1, 2, 3, 4]" width="100%" height="18px" styleClass="dl-skeleton-row"></p-skeleton>
  </div>

  <div *ngIf="changelogState === 'error'" class="dl-changelog-error" role="alert">
    <p>{{ 'downloads.changelogErr' | transloco }}</p>
    <button type="button" class="dl-retry" (click)="loadChangelog()">
      <i class="pi pi-refresh"></i>
      {{ 'downloads.retry' | transloco }}
    </button>
  </div>

  <div *ngIf="changelogState === 'ready'" class="dl-changelog-body" [innerHTML]="changelogHtml"></div>
</p-dialog>
